
<div>
  <ul class="tag-listing">
    <li v-for="chip in alwaysShownChips">
      <pill @onRemove="destroy(chip)" :value="chip[displayKey]" color="Orange"></pill>
    </li>
  </ul>
  <div class="cta-container" v-if="hasRevealableChips">
    <span class="hidden-counter" v-show="!isOpen" :class="{'sr-only': isOpen}">+ {{revealableCount}} more</span>
    <button
      type="button"
      @click="toggleOpen"
      :id="`moreChipsButton_${rootId}`"
      class="btn-icon light-grey show-tags collapsed"
      data-toggle="collapse"
      :data-target="`#moreChips_${rootId}`"
      aria-expanded="false">
      <icon class="arrow-chevron"></icon>
      <span class="sr-only">More Chips Dropdown</span>
    </button>
  </div>
  <div class="filter-expanded">
    <ul :id="`moreChips_${rootId}`" class="collapse tag-listing">
      <li v-for="chip in revealableChips">
        <pill @onRemove="destroy(chip)" :value="chip[displayKey]" :color="pillColor"></pill>
      </li>
    </ul>
  </div>
</div>
